import { createContext } from 'react';

export const Context = createContext({
    api: null,
    url: null,
    storage: null
});
